import React, { FC } from 'react'

import { css } from '@emotion/core'
import flexCenter from 'utils/styles/flexCenter'

import GoogleLogin, { GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login'

type GoogleLoginButtonProps = {
  cbAction: (response: GoogleLoginResponse | GoogleLoginResponseOffline) => void
  buttonText?: string
  disabled?: boolean
}

const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID as string

const GoogleLoginButton: FC<GoogleLoginButtonProps> = ({ cbAction, buttonText, disabled }) => {
  const responseGoogle = (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    cbAction && cbAction(response)
  }

  return (
    <GoogleLogin
      clientId={GOOGLE_CLIENT_ID}
      buttonText={buttonText || 'Sambungkan dengan Google'}
      onSuccess={responseGoogle}
      onFailure={responseGoogle}
      cookiePolicy={'single_host_origin'}
      disabled={disabled}
      css={css`
        width: 100%;
        ${flexCenter}
        div {
          ${flexCenter}
          margin-right: 0 !important;
          padding: 1rem 10px !important;
        }
        span {
          font-size: 1rem !important;
          font-weight: bold !important;
        }
      `}
    />
  )
}

export default GoogleLoginButton
